import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Record } from './record';
import { RecordService } from './record.service';
import { lookupParam } from '../nav/utils';

@Injectable()
export class RecordResolver implements Resolve<Record> {

  constructor(
    private router: Router,
    private recordService: RecordService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Record | Observable<Record> | Promise<Record> {
    return new Promise<Record>(async (resolve, reject) => {

      let record_id = lookupParam(route, 'record_id');

      this.recordService
        .record(record_id)
        .subscribe((record) => {
          
          if(record) {
            return resolve(record);
          }
          else {
            this.router.navigate(['records']);
            return resolve(null);
          }
        });
    });
  }
}